import { Box, css, CSSProp, Flex, styled, StyleSystemProps, Theme } from '@withjoy/joykit';

export const StyledPillWrapper = styled(Flex)<{ $css?: CSSProp<Theme> }>``;

export const getPillWrapperStyles = ({ size, variant }: { size: 'md' | 'sm'; variant: 'pill' | 'minimal' }): {} => {
  return {
    flexWrap: 'wrap',
    gridGap: size === 'md' ? 4 : 3,
    [StyledPill]: {
      ...(size === 'sm'
        ? {
            fontSize: '13px',
            fontWeight: 400
          }
        : undefined),
      [StyledPillLabel]: {
        ...pillLabelStyles,
        ...(variant === 'minimal' ? minimalLabelStyles : undefined)
      }
    }
  };
};

export const StyledPill = styled(Box)<{ isQuickAddForm?: boolean }>`
  display: inherit;
  ${props => {
    if (props.isQuickAddForm) {
      return css`
        width: fit-content;
      `;
    }

    return css`
      text-align: center;
      font-size: 14px !important;
      height: 47px;
    `;
  }}
`;

export const StyledPillLabel = styled(Box)<{ isQuickAddForm?: boolean }>``;

const pillInputStyles: StyleSystemProps = {
  appearance: 'none'
};

const pillLabelStyles: StyleSystemProps = {
  padding: 4,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderRadius: '4px',
  borderColor: 'mono5',
  transition: 'border-color 0.5s cubic-bezier(0.23, 1, 0.32, 1)',
  cursor: 'pointer',
  _checked: {
    borderColor: 'mono14',
    _hover: {
      borderColor: 'mono14'
    }
  },
  _hover: {
    borderColor: 'mono7'
  },
  _readOnly: {
    color: 'mono8',
    textDecoration: 'line-through'
  }
};

// TODO: Replace with minimal variant styles
const minimalLabelStyles: StyleSystemProps = {
  ...pillLabelStyles
};

export const styles = {
  pillInput: pillInputStyles
};
